import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from '../_services/notification.service';
import { TokenStorageService } from '../_services/token-storage.service';
import { UserService } from '../_services/user.service';
import { RaizComponent } from '../raiz/raiz.component';

@Component({
  selector: 'app-clave',
  templateUrl: './clave.component.html',
  styleUrls: ['./clave.component.css']
})
export class ClaveComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private tokenStorage: TokenStorageService,
    private usuarioService: UserService,
    private notificationService: NotificationService,
    private raiz: RaizComponent,
    private translate: TranslateService
  ) {

  }

  ngOnInit(): void {
    var id: any = this.route.snapshot.paramMap.get("id");
    if (id != -1) {
      this.tokenStorage.saveToken(this.route.snapshot.paramMap.get("id"));
      this.usuarioService.getCurrentUserFromServer().subscribe({
        next: (data) => {

          if (data.Usuario != null) {
            if (data.pending2FAEnrollment) {
              this.tokenStorage.setPending2FAEnrollment(true);
              this.router.navigate(['/login']);
              return;
            }
            this.tokenStorage.setPending2FAEnrollment(false);
            this.tokenStorage.setUser(data.Usuario, data.usuarioRepresenta);
            if (data.Usuario.email) {
              this.raiz.reloadHeader = !this.raiz.reloadHeader;
              this.router.navigate(['/admin']);
            } else {
              this.raiz.reloadHeader = !this.raiz.reloadHeader;
              this.router.navigateByUrl('/admin?action=20');
            }
          }
          else {
            this.notificationService.error(
              this.translate.instant('COMMON.ERROR'),
              this.translate.instant('LOGIN.MSG.USER_NOT_FOUND'),
              50000
            );
            this.router.navigate(['/login']);
          }
        },
        error: (error) => {
          if (error.error.status == 651) {
            this.notificationService.errorRedir(
              this.translate.instant('COMMON.ERROR'),
              this.translate.instant('LOGIN.MSG.USER_DEACTIVATED'),
              50000,
              this.translate.instant('LOGIN.MSG.REACTIVATE_HINT'),
              '../forgot-password'
            );
            this.logout();
            this.router.navigate(['/login']);
          }
          else {
            this.notificationService.error(
              this.translate.instant('COMMON.ERROR'),
              this.translate.instant('LOGIN.MSG.USER_RECOVER_FAIL')
            );
            this.router.navigate(['/login']);
          }
        },
      })
    }
    else {
      this.notificationService.error(
        this.translate.instant('COMMON.ERROR'),
        this.translate.instant('LOGIN.MSG.USER_NOT_FOUND'),
        50000
      );
      this.router.navigate(['/login']);
    }
  }
  logout(): void {
    this.tokenStorage.signOut();
  }
}
